/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconNfcOff = createReactComponent("outline", "nfc-off", "IconNfcOff", [["path", { "d": "M11 20a3 3 0 0 1 -3 -3v-9", "key": "svg-0" }], ["path", { "d": "M13 4a3 3 0 0 1 3 3v5m0 4v2l-5 -5", "key": "svg-1" }], ["path", { "d": "M8 4h9a3 3 0 0 1 3 3v9m-.873 3.116a2.99 2.99 0 0 1 -2.127 .884h-10a3 3 0 0 1 -3 -3v-10c0 -.83 .337 -1.582 .882 -2.125", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

export { IconNfcOff as default };
//# sourceMappingURL=IconNfcOff.mjs.map
